import { useRouter } from 'next/compat/router';
import { useCallback } from 'react';

import { type AllOption } from '../../components/typeahead/CategoryTypeahead';
import { type CategoryTypeaheadCategoryFragment } from '../../components/typeahead/__generated-gql-types__/CategoryTypeahead.generated';
import mxpnl from '../analytics/mixpanel';
import phog from '../analytics/posthog/posthog';
import { BOOTCAMPS_RELATIVE_URL, EVENTS_RELATIVE_URL } from '../constants';

export const ALL_CATEGORIES_OPTION: AllOption = {
  id: 'all',
  slug: 'all',
  name: 'All categories',
};

export enum CategorySource {
  EVENTS = 'Event',
  BOOTCAMPS = 'Bootcamp',
}

export const useChangeCategory = ({
  handleNavigation,
  type,
}: {
  handleNavigation: boolean;
  type: CategorySource;
}) => {
  const router = useRouter();

  return useCallback(
    async (
      category: CategoryTypeaheadCategoryFragment,
      source: 'dropdown' | 'tags',
    ) => {
      const event =
        source === 'dropdown'
          ? `${type}CategoryDropdown Click`
          : `${type}CategoryTags Click`;
      const posthogEvent =
        source === 'dropdown'
          ? `${type.toLowerCase()}s_page--category_dropdown_click`
          : `${type.toLowerCase()}s_page--category_tags_click`;

      mxpnl.track(event, {
        category: category.id,
      });
      phog.capture(posthogEvent, {
        category: category.id,
      });
      if (handleNavigation) {
        await router?.push(
          getCategorySRPUrl(
            category.id === ALL_CATEGORIES_OPTION.id ? undefined : category,
            type === CategorySource.EVENTS
              ? EVENTS_RELATIVE_URL
              : BOOTCAMPS_RELATIVE_URL,
          ),
        );
      }
    },
    [router, handleNavigation, type],
  );
};

export const getCategorySRPUrl = (
  category: Possible<CategoryTypeaheadCategoryFragment>,
  relativeUrl: string,
) => {
  if (!category) {
    return relativeUrl;
  }
  return `/${category.goal.toLowerCase()}/${category.slug}${relativeUrl}`;
};
